module.exports = __webpack_public_path__ + "img/2013_S.36efbd58.png";